import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';

interface itemType {
    title: string;
    desc: string;
    img: [string, string];
}
export default function B() {
    const { t } = useLang('bkw');
    const items: itemType[] = [
        {
            title: 'B_item1_title',
            desc: t('B_item1_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738821575107/2_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738823559025/2_1_M.jpg'],
        },
        {
            title: 'B_item2_title',
            desc: t('B_item2_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738821574606/2_2.png', 'https://websiteoss.ecoflow.com/upload/image/1738823559187/2_2_M.png'],
        },
        {
            title: 'B_item3_title',
            desc: t('B_item3_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738821575275/2_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738823548941/2_3_M.jpg'],
        },
        {
            title: 'B_item4_title',
            desc: t('B_item4_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738821575009/2_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1738823549512/2_4_M.jpg'],
        },
        {
            title: 'B_item5_title',
            desc: t('B_item5_desc'),
            img: ['https://websiteoss.ecoflow.com/upload/image/1738821574767/2_5.png', 'https://websiteoss.ecoflow.com/upload/image/1739765103413/2_5_M.jpg'],
        },
    ];

    return (
        <div id="bkw-B" className={`bkw-B bkw-box ${css['bkw-B']}`}>
            <EfSpec />
            <div className="info">
                <h2 className="title">
                    {t.rich('B_title', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </h2>
            </div>
            <ul className="items">
                {items.map((item: itemType, k: number) => (
                    <li className={`item item-${k + 1}`} key={k} style={{ gridArea: `x${k + 1}` }}>
                        <EfImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        <div className="item-info">
                            <p className="item-title">
                                {t.rich(item.title, {
                                    y: (tx: string) => <span className="y">{tx}</span>,
                                })}
                            </p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
